import { HttpClient } from "@angular/common/http";
import * as Sentry from '@sentry/angular';
import { ThisReceiver } from "@angular/compiler";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { CustomerDTO } from "../models/Customers/CustomerDTO";
import { CustomersService } from "./ServiceCatalogEncapsulators/Customers.service";
import { BehaviorSubject, Subscription } from "rxjs";
import { EnumExternalMapUrl, EnumMapUrl } from "../helpers/enums/EnumCatalogNames copy";
import { LocalStorageService } from "./LocalStorage.service";
@Injectable({
  providedIn: "root",
})
export class SessionService {
  public isMapix: boolean = false;
  public isExternalMap: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public loadedMapComponents: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public Customer: CustomerDTO;
  private configUrl = "";

  subscription_GetCustomer: Subscription;

  constructor(
    private http: HttpClient,
    private CustomerService: CustomersService,
    private router: Router,
    private localStorageService: LocalStorageService
    ) {
    this.configUrl = environment.host;
    this.CheckURLSource();
  }

 CheckURLSource() {
    const mapixHosts = [
      "mapix.einteligent.com",
      "mapix.test.einteligent.com",
      "mapix.dev.einteligent.com",
      "mapixstage.test.einteligent.com",
      "localhost:4200",
      "mapixv2.einteligent.com"
    ];
    const redirectPath = this.localStorageService.getRedirectUrl();
    const enumValues = Object.values(EnumExternalMapUrl);

    try {
      const host = window.parent.location.host;
      this.isMapix = mapixHosts.includes(host);
      
      if( redirectPath && enumValues.includes(redirectPath as EnumExternalMapUrl)){
        this.isExternalMap.next(true);
      }
    } catch (e) {
      this.isMapix = false;
      if( redirectPath && enumValues.includes(redirectPath as EnumExternalMapUrl)){
        this.isExternalMap.next(true);
      }else{
        this.isExternalMap.next(false);
      }
    }
  }

  getAPIversion() :any{
    if(!environment.production) console.log("/api/System/GetAPIVersion/");
    return this.http.get<string>(
      this.configUrl + "/api/System/GetAPIVersion");
  }

  getCustomerId(){
    if (this.subscription_GetCustomer && !this.subscription_GetCustomer.closed) {
      return;
    }
    this.subscription_GetCustomer = this.CustomerService.getRefererClient().subscribe({
      next: (d)=>{
        if(d.isSuccess==true){
          if(!environment.production) console.log("GET /api/Customer/GetbyClientId/ ", d);
          
          this.Customer = d.result;
          this.subscription_GetCustomer.unsubscribe();
        } else {
          Sentry.captureMessage('SessionService.getRefererClient: isSuccess false', { level: 'warning', extra: { response: d } });
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener cliente', error);
        this.subscription_GetCustomer.unsubscribe();
      }
    });
  }

  

  ReloadPage(){
    var currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>{
      this.router.navigate([currentUrl]);
    });
  }

  setIsExternalMap(value: boolean){
    this.isExternalMap.next(value);
  }
}
